import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

const styles = {
  groupStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  groupBadgeStyles: {
    backgroundColor: '#E8F3EC',
    borderRadius: '999px',
    color: '#286840',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.25em 0.55em',
    textAlign: 'center',
  },
  styles: {
    container: base => ({
      ...base,
      flex: 1
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: '38px',
      height: '38px',
      borderColor: state.isFocused ? '#286840' : '#D5E3DA',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(40, 104, 64, 0.12)' : 'none',
      borderRadius: '12px',
      backgroundColor: '#fff',
      '&:hover': {
        borderColor: '#286840'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 10px',
      marginTop: '0'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      maxHeight: '38px'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#286840' : state.isFocused ? '#E8F3EC' : '#fff',
      color: state.isSelected ? '#fff' : '#3D4A42',
      fontSize: '0.85rem',
      borderRadius: '8px',
      margin: '2px 4px',
      width: 'calc(100% - 8px)'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '16px',
      overflow: 'hidden',
      border: '1px solid #D5E3DA',
      boxShadow: '0 8px 24px rgba(20, 53, 40, 0.1)',
      zIndex: 5,
      padding: '4px'
    })
  }
}

const Select = ({ classNameParent, text, size, icon, onChange, value, defaultValue, className, options, append, disabled, ...props }) => {
  const propValue = useCallback(() => {
    return defaultValue ? { defaultValue } : { value }
  }, [defaultValue, value])
  
  return (<div className={classNameParent}>
    <small className="text-muted">{text}</small>
    <div className={'input-group input-group-' + size}>
      {icon ? <div className="input-group-prepend">
        <div className="input-group-text"><i className={icon}></i></div>
      </div> : ''}
      <ReactSelect
        styles={styles.styles}
        options={options}
        {...propValue()}
        onChange={e => onChange(e)}
        formatGroupLabel={data => {
          return <div style={styles.groupStyles}>
            <span>{data.label}</span>
            <span style={styles.groupBadgeStyles}>{data.options.length}</span>
          </div>
        }}
        placeholder="Seleccionar..."
        {...props}
        isDisabled={disabled}
      />
      <div className="input-group-append">
        {React.Children.toArray(append)}
      </div>
    </div>
  </div>)
}

Select.defaultProps = {
  size: 'sm',
  icon: '',
  classNameParent: 'col-12',
  required: false,
  append: [],
  options: [],
  onChange: () => {},
  disabled: false
}
Select.propTypes = {
  classNameParent: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  icon: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
  append: PropTypes.array,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}

export default Select